export default __webpack_public_path__ + "static/media/bg-header.3c5ea30e.png";